export default "__VITE_ASSET__d426f012__$_?inline__"